<template>
  <el-col id="day-docs" :span="3">
    <el-col :span="16" class="texts">
      <p>Акты:</p>
      <p>ТТН:</p>
      <p>Оплаты:</p>
    </el-col>
    <el-col :span="8" class="values">
      <loader-wrapper
        :loading="loading"
        background="rgba(244,244,244,.9)"
        spinner="el-icon-loading"
      >
        <p :class="checkDiff('acts')">
          {{ info ? info.acts.total : 0 }}
        </p>
        <p :class="checkDiff('ttns')">
          {{ info ? info.ttns.total : 0 }}
        </p>
        <p :class="checkDiff('payments')">
          {{ info ? info.payments.total : 0 }}
        </p>
      </loader-wrapper>
    </el-col>
  </el-col>
</template>

<script>
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'DocCount',
  components: { LoaderWrapper },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    checkDiff(key) {
      if (!this.info || !this.info[key]) {
        return ''
      }
      const { total, approved_count } = this.info[key]

      return total > 0 && total === approved_count ? 'green' : ''
    },
  },
}
</script>

<style lang="sass">
#day-docs
  padding: 0 !important
  p
    margin: 0
    line-height: 22px
  .texts
    padding: 0 !important
    p
      display: flex
      align-items: center
      justify-content: flex-end
  .values
    padding: 0 10px 0 5px !important
    .el-loading-spinner
      margin-top: -15px
    p
      display: flex
      align-items: center
      justify-content: flex-start
      &.green
        color: #4C9429
</style>
